module.exports = __webpack_public_path__ + "static/img/operateVip.03c745b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateVip.png
// module id = Ye4g
// module chunks = 1